import type { ReactNode } from 'react';

export interface EmptyStateProps {
  /** A friendly 28 px Tabler icon. */
  icon?: ReactNode;
  /** What this means, in a few words ("Nothing booked yet"). */
  title: ReactNode;
  /** One or two sentences: why it's empty and what happens next. */
  children?: ReactNode;
  /** The one next action (full-width Button). */
  action?: ReactNode;
  /** An optional second, quieter action (variant="default" or subtle). */
  secondaryAction?: ReactNode;
  /** Render without the card (inside another card). */
  plain?: boolean;
}

/** Empty list or screen: says what it means and offers the one next action. */
export function EmptyState({ icon, title, children, action, secondaryAction, plain }: EmptyStateProps) {
  return (
    <div className={`rides-empty${plain ? '' : ' rides-card'}`}>
      {icon && <span className="ic" aria-hidden="true">{icon}</span>}
      <h2>{title}</h2>
      {children && <div className="desc">{children}</div>}
      {(action || secondaryAction) && (
        <div className="acts">
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
}
